import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Disclaimer } from "../pages/Disclaimer";
import { Termcon } from "../pages/Termcon";
import { Topbar } from "./Topbar";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar  navbar-expand-lg  ">
        <Link to="/" className="navbar-brand" href="#">
          <span style={{ fontSize: "30px", fontWeight: 800 }}>TP</span>
          <span style={{ fontSize: "10px", fontWeight: 600, color: "#fff" }}>
            TrickPiece
          </span>
        </Link>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item active">
            <NavLink
              exact
              activeClassName="active"
              className="nav-link text-white font-weight-bold"
              to="/"
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              activeClassName="active"
              className="nav-link font-weight-bold text-white"
              to="/about"
            >
              About
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
